import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

export default function FinalCTA() {
  const { pathFor, t } = useLanguage();
  const cta = t.finalCta;
  if (!cta) return null;

  return (
    <section className="relative bg-ct-ink text-white overflow-hidden">
      <div
        aria-hidden="true"
        className="absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            'linear-gradient(to right, rgba(255,255,255,0.6) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.6) 1px, transparent 1px)',
          backgroundSize: '40px 40px',
        }}
      />
      <div
        aria-hidden="true"
        className="absolute -top-32 -right-32 w-[480px] h-[480px] bg-ct-brand/25 blur-[140px] rounded-full"
      />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 border border-white/20 bg-white/5 px-3 py-1 mb-6">
            <span className="ct-live-dot" />
            <span className="text-[11px] font-bold uppercase tracking-widest text-white/80">
              {cta.badge}
            </span>
          </div>

          <h2
            className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-[1.05] mb-6"
            style={{ fontFamily: 'Chivo, sans-serif' }}
          >
            {cta.title}
          </h2>
          <p className="text-lg text-white/70 leading-relaxed max-w-xl mb-10">{cta.subtitle}</p>

          <div className="flex flex-wrap gap-3">
            <Link
              to={pathFor('/setup')}
              data-testid="final-cta-primary"
              className="group inline-flex items-center gap-2 bg-ct-brand hover:bg-ct-brand-hover text-white font-bold uppercase tracking-wider text-sm px-6 h-12 transition-colors duration-200 ct-shadow-md cursor-pointer"
            >
              {cta.primary}
              <ArrowRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-0.5" />
            </Link>
            <Link
              to={pathFor('/signin')}
              data-testid="final-cta-secondary"
              className="inline-flex items-center gap-2 bg-transparent border border-white/30 hover:border-white text-white font-bold uppercase tracking-wider text-sm px-6 h-12 transition-colors duration-200 cursor-pointer"
            >
              {cta.secondary}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
